export default __webpack_public_path__ + "static/media/no.af9b74eb.svg";